// =============================================================================
// src/data/analytics-scope-where.ts — Escopo do feed decidido NO SERVIDOR.
//
// 2026-09-02 (plano "Cenario AM (Nucleo) por padrao + chips Omar/Contexto"):
// os 7 buckets do dashboard sao `LIMIT 12/8/4` no Hasura, ordenados por likes/
// engajamento/recencia sobre o cenario inteiro — filtrar no DOM deixaria 0-2
// cards por bucket (os comentarios em espanhol sobre jacares ocupavam o top-12
// mesmo escondidos). O escopo entra no `where`, por isso a query e GERADA por
// escopo (GraphQL nao parametriza `where` por enum). Funcoes puras, testaveis.
// =============================================================================

export type AnalyticsFeedScope = 'nucleo' | 'omar' | 'contexto';

export const ANALYTICS_FEED_SCOPES: readonly AnalyticsFeedScope[] = ['nucleo', 'omar', 'contexto'];
export const ANALYTICS_DEFAULT_FEED_SCOPE: AnalyticsFeedScope = 'nucleo';

/** Rotulos do rail "Escopo" e do cabecalho do feed (mesmo vocabulario). */
export const ANALYTICS_SCOPE_LABELS: Readonly<Record<AnalyticsFeedScope, string>> = {
  nucleo: 'Nucleo',
  omar: 'Omar',
  contexto: 'Contexto',
};

export interface AnalyticsScopeWhereOptions {
  readonly scope: AnalyticsFeedScope;
  /** true = comentarios 'reacao' ("Volta Omar 5️⃣5️⃣") tambem entram; 'vazio' NUNCA. */
  readonly showReactions: boolean;
}

/** Valor do chip/attr → escopo tipado; null para valor desconhecido. */
export function parseAnalyticsFeedScope(value: string | null | undefined): AnalyticsFeedScope | null {
  return ANALYTICS_FEED_SCOPES.find((scope) => scope === value) ?? null;
}

/**
 * Substancia do comentario (migration 024): post/news passam sempre; comentario
 * so com texto para ler. Clausula `_or` porque os buckets misturam kinds.
 *
 * @example analyticsSubstanceWhere(false) // '_or: [{ content_kind: { _nin: ["comment", "reply"] } }, { text_substance: { _in: ["substantivo"] } }]'
 */
export function analyticsSubstanceWhere(showReactions: boolean): string {
  const allowed = showReactions ? '["substantivo", "reacao"]' : '["substantivo"]';
  return `_or: [{ content_kind: { _nin: ["comment", "reply"] } }, { text_substance: { _in: ${allowed} } }]`;
}

/**
 * Fragmento de `where` do escopo (sem client_id — cada bucket ja o carrega).
 * 'omar' = nucleo + relacao com o VIP (migration 025: publicacao propria,
 * citacao ou comentario em post proprio); 'contexto' = AM sem carga politica.
 *
 * @example analyticsScopeWhere({ scope: 'omar', showReactions: false })
 */
export function analyticsScopeWhere(options: AnalyticsScopeWhereOptions): string {
  const verdict = options.scope === 'contexto' ? 'contexto' : 'nucleo';
  const vipClause = options.scope === 'omar' ? ', vip_relation: { _neq: "nenhuma" }' : '';
  return `relevance_verdict: { _eq: "${verdict}" }${vipClause}, ${analyticsSubstanceWhere(options.showReactions)}`;
}
